// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3j_ZZ","inputDescription":"styles_inputDescription__1q2jc"};